import React, { useState } from "react";
import {
  IonModal,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonSpinner,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonTitle,
  IonIcon,
  IonButton,
} from "@ionic/react";

import { checkmarkOutline, arrowBackOutline } from "ionicons/icons";

import useVacancySearch from "../useVacancySearch";
import useGrouping from "../useGrouping";
import useInfinite from "../../../hooks/useInfinite";

import "./style-select.css";

import { VacancyGrouped } from "../../../interfaces/passage";
import moment from "moment";

interface SelectDateProps {
  open?: boolean;
  startAt: string;
  selectDate?: string;
  handleClose?: (event: any) => void;
  departure_location_id?: string;
  arrival_location_id?: string;
}

const SelectDateModal: React.FC<SelectDateProps> = ({
  startAt,
  selectDate,
  departure_location_id,
  arrival_location_id,
  open = true,
  handleClose = () => {},
}) => {
  const [page, setPage] = useState<number>(1);

  const { error, hasMore, list, loading } = useVacancySearch("getVacancies", {
    departure_location_id,
    arrival_location_id,
    pageNumber: page,
    date: startAt,
    limit: 20,
  });

  const { refElLast } = useInfinite({ loading, hasMore, setPage });

  const { vacanciesGroupDate } = useGrouping(list);

  const onClick = (item: VacancyGrouped) => () => handleClose(item);

  if (!open) {
    return null;
  }

  return (
    <IonContent>
      <IonModal backdropDismiss={false} isOpen={open}>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonButton onClick={() => handleClose(null)}>
                <IonIcon icon={arrowBackOutline} />
              </IonButton>
            </IonButtons>
            <IonTitle>Selecione data</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonList style={{ overflowY: "auto" }}>
            {vacanciesGroupDate.map((vacancy: VacancyGrouped, i: number) => {
              const selected = selectDate === vacancy.date;
              const className = selected ? "selected" : "";
              if (vacanciesGroupDate.length === i + 1) {
                return (
                  <IonItem
                    className={className}
                    ref={refElLast}
                    button
                    onClick={onClick(vacancy)}
                    key={`select-date-${i}`}
                  >
                    <IonLabel>
                      {moment(vacancy.date).format("DD/MM/YYYY")}
                    </IonLabel>
                    {selected ? (
                      <IonIcon slot="end" icon={checkmarkOutline} />
                    ) : null}
                  </IonItem>
                );
              }
              return (
                <IonItem
                  button
                  className={className}
                  onClick={onClick(vacancy)}
                  key={`select-date-${i}`}
                >
                  <IonLabel>
                    {moment(vacancy.date).format("DD/MM/YYYY")}
                  </IonLabel>
                  {selected ? (
                    <IonIcon
                      color="primary"
                      slot="end"
                      icon={checkmarkOutline}
                    />
                  ) : null}
                </IonItem>
              );
            })}
          </IonList>
          {loading ? (
            <div className="loading">
              <IonSpinner className="loading" />
              <span>Carregando novas vagas...</span>
            </div>
          ) : null}
        </IonContent>
      </IonModal>
    </IonContent>
  );
};

export default SelectDateModal;
